module.exports = __webpack_public_path__ + "img/10.ece49a2b.jpg";